import { useSession } from '~/components/contexts/SessionProvider';
import { Link } from 'react-router-dom';

export const ProfileImage = ({ size = 'sm' }: { size?: 'sm' | 'lg' }) => {
  const { owner } = useSession();

  return (
    <Link to={'/profile'} data-testid="profile-image">
      <div
        className={`mb-5 ${
          size === 'sm' ? 'h-10 w-10' : 'h-32 w-32'
        } flex items-center justify-center rounded-full bg-slate-300`}
      >
        <p
          className={` text-center ${
            size === 'sm' ? ' text-sm font-medium' : ' text-3xl font-medium'
          }`}
        >
          {owner.email.slice(0, 2).toUpperCase()}
        </p>
      </div>
    </Link>
  );
};
